// Links handing a route over to a navigation app (#23654). An Android geo: URI only takes one point, so the route is
// sent as an https link to each app, which Android and iOS open in the app when it is installed.

const MAX_GOOGLE_MAPS_WAYPOINTS = 9;

const toLatLng = ([lng, lat]) => `${lat},${lng}`;

/**
 * Google Maps directions (Maps URLs API). Without an origin Google Maps starts from the device's position, and
 * dir_action=navigate starts the guidance. It takes at most 9 intermediate waypoints: the route then ends at the 10th stop.
 * @param {Array<[number, number]>} stops - [lng, lat] points left to drive to, in order
 * @returns {string|null}
 */
export function buildGoogleMapsNavigationUrl(stops) {
	const points = (stops || []).slice(0, MAX_GOOGLE_MAPS_WAYPOINTS + 1).map(toLatLng);
	if (points.length === 0) return null;
	const params = new URLSearchParams({ api: '1', destination: points[points.length - 1], travelmode: 'driving', dir_action: 'navigate' });
	if (points.length > 1) params.set('waypoints', points.slice(0, -1).join('|'));
	return `https://www.google.com/maps/dir/?${params}`;
}

/**
 * Waze navigation to the first stop: Waze has no multi-stop link.
 * @param {Array<[number, number]>} stops - [lng, lat] points left to drive to, in order
 * @returns {string|null}
 */
export function buildWazeNavigationUrl(stops) {
	const first = stops?.[0];
	return first ? `https://waze.com/ul?ll=${toLatLng(first)}&navigate=yes` : null;
}
